import React from 'react';
import { Link } from 'react-router-dom';

const services = [
  {
    icon: '🌐', title: 'Web Development', tag: 'Core Service',
    desc: 'We design and build fast, responsive, SEO-friendly websites and web applications using React, Next.js, Laravel, WordPress and more. From landing pages to complex portals — we handle it all.',
    features: ['React / Next.js / Vue.js', 'Laravel / Node.js / PHP', 'REST API & GraphQL', 'Performance & SEO Optimisation', 'CMS Integration', 'Progressive Web Apps (PWA)'],
  },
  {
    icon: '📱', title: 'Mobile App Development', tag: 'High Demand',
    desc: 'Native Android & iOS development plus cross-platform apps with Flutter and React Native. We build apps that users love and businesses depend on.',
    features: ['Android (Kotlin/Java)', 'iOS (Swift)', 'Flutter (cross-platform)', 'React Native', 'App Store & Play Store publishing', 'Push notifications & analytics'],
  },
  {
    icon: '🎨', title: 'UI/UX Design', tag: 'Creative',
    desc: 'Great design is more than looks — it is about creating intuitive experiences that convert. We deliver wireframes, prototypes, and production-ready Figma designs.',
    features: ['User Research & Personas', 'Wireframing & Prototyping', 'Figma / Adobe XD Design', 'Brand Identity & Logo', 'Design Systems', 'Usability Testing'],
  },
  {
    icon: '📈', title: 'Digital Marketing', tag: 'Growth',
    desc: 'Data-driven marketing strategies that bring qualified traffic and convert visitors into customers. SEO, Google Ads, Meta Ads, content and email marketing.',
    features: ['Search Engine Optimisation (SEO)', 'Google Ads (PPC)', 'Meta / Instagram Ads', 'Content Marketing', 'Email Marketing', 'Analytics & Reporting'],
  },
  {
    icon: '🛒', title: 'E-Commerce Solutions', tag: 'Sales',
    desc: 'Online stores built to sell. WooCommerce, Shopify, Magento, or fully custom platforms — with payment gateways, inventory management, and conversion optimisation.',
    features: ['WooCommerce / Shopify', 'Custom E-Commerce', 'Payment Gateway Integration', 'Inventory & Order Management', 'Multi-currency & Multi-language', 'Conversion Rate Optimisation'],
  },
  {
    icon: '☁️', title: 'Cloud & DevOps', tag: 'Infrastructure',
    desc: 'Scalable, reliable cloud infrastructure. We set up CI/CD pipelines, containerise apps with Docker, and manage AWS, Azure, and GCP deployments.',
    features: ['AWS / Azure / GCP', 'Docker & Kubernetes', 'CI/CD Pipelines', 'Server Setup & Management', 'Database Optimisation', 'Monitoring & Alerting'],
  },
  {
    icon: '🤖', title: 'AI & Automation', tag: 'Future-Ready',
    desc: 'Integrate AI capabilities into your product — chatbots, recommendation engines, data analysis, and workflow automation that saves hours every day.',
    features: ['ChatGPT / OpenAI Integration', 'Custom ML Models', 'Business Process Automation', 'Chatbot Development', 'Data Analytics & BI', 'NLP & Computer Vision'],
  },
  {
    icon: '🔒', title: 'Cyber Security', tag: 'Security',
    desc: 'Protect your digital assets with proactive security audits, penetration testing, and secure development practices built into every project.',
    features: ['Penetration Testing', 'Vulnerability Assessments', 'SSL & HTTPS Setup', 'Secure Code Review', 'GDPR & Compliance', 'Security Monitoring'],
  },
];

export default function Services() {
  return (
    <main className="vt-page">

      {/* Hero */}
      <section className="vt-page-hero">
        <div className="vt-page-hero__overlay" />
        <div className="vt-container vt-page-hero__content">
          <span className="vt-page-hero__eyebrow">Our Services</span>
          <h1 className="vt-page-hero__title">Technology Services Built For Your Business</h1>
          <p className="vt-page-hero__sub">From web development to AI — we are your end-to-end technology partner in Ahmedabad.</p>
        </div>
      </section>

      {/* Services Grid */}
      <section className="vt-section">
        <div className="vt-container">
          <div className="vt-services-full-grid">
            {services.map((s, i) => (
              <div key={i} className="vt-service-full-card">
                <div className="vt-service-full-card__top">
                  <span className="vt-service-full-card__icon">{s.icon}</span>
                  <span className="vt-service-full-card__tag">{s.tag}</span>
                </div>
                <h3>{s.title}</h3>
                <p>{s.desc}</p>
                <ul className="vt-service-full-card__features">
                  {s.features.map((f, j) => (
                    <li key={j}><span className="vt-check">✔</span>{f}</li>
                  ))}
                </ul>
                <Link to="/contact" className="vt-service-full-card__btn">Get a Quote →</Link>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="vt-cta-banner">
        <div className="vt-container vt-cta-banner__inner">
          <div>
            <h2>Need a Custom Solution?</h2>
            <p>Tell us your requirements and we will craft the perfect plan for you.</p>
          </div>
          <div className="vt-cta-banner__actions">
            <Link to="/contact" className="vt-btn vt-btn--white">Contact Us Now</Link>
          </div>
        </div>
      </section>
    </main>
  );
}
